import Register from "../components/Register"
import Footer from "../components/Footer"

const RegisterPage = () => {
    return (
        <>
            <div className="register__body">
                <Register />
            </div>
            <Footer />
        </>
    )
}

export default RegisterPage
